import React from "react";
import styles from "./cv-new.module.scss";
import Header from "./header/header";
import Section from "./section/section";
import ExperienceCard from "./experience-card/experience-card";
import Skills from "./skills/skills";
import Education from "./education/education";
import Contact from "./contact/contact";

const CVNew: React.FC = () => {
  const experiences = [
    {
      company: "Interhyp Gruppe",
      location: "München",
      role: "Fullstack Engineer",
      period: "February 2023 – present",
      description: [
        "comparison portal real estate trading",
        '"Home" as new portal in the future',
        "cloud based network of around 100 microservices",
      ],
    },
    {
      company: "SprintEins GmbH",
      location: "München",
      role: "Fullstack Developer",
      period: "June 2021 – December 2022",
      description: [
        "emission certification process tool for mercedes-benz",
        'assisting from certification inquiry to .doc-export to the "KBA"',
        "non-profit projects in cooperation with caritas",
      ],
    },
    {
      company: "Juconn GmbH",
      location: "Unterföhring",
      role: "Software Developer",
      period: "June 2019 – December 2020",
      description: [
        "IoT sensor data processing and visualizing",
        "automatic generated reports",
        "microservices in nestJs/typescript",
      ],
    },
    {
      company: "Wunderlabs UG",
      location: "Hallbergmoos",
      role: "Software Developer",
      period: "March 2019 - June 2019",
      description: [
        "responsive websites with mobile first architecture",
        "backends with python based crms",
      ],
    },
    {
      company: "Artus Management GmbH",
      location: "Kulmbach",
      role: "Software Developer",
      period: "June 2018 – February 2019",
      description: ["automated arbitrage trading with crypto currencies"],
    },
  ];

  return (
    <div className={styles.cvContainer}>
      <div className={styles.content}>
        <Header />

        <Section title="Professional Background">
          <div className={styles.experienceList}>
            {experiences.map((exp, index) => (
              <ExperienceCard key={index} {...exp} />
            ))}
          </div>
        </Section>

        <Section title="Skills">
          <Skills />
        </Section>

        <Section title="Education">
          <Education />
        </Section>

        <Section title="Contact">
          <Contact />
        </Section>
      </div>
    </div>
  );
};

export default CVNew;
